module.exports = __webpack_public_path__ + "static/bg-2-f644edb203bb63baf6fc33bee252ff26.jpeg";